import {
  DataFormatInstrumentFilters,
  dataFormatInstrumentsConstants,
  DataFormatInstrumentSortingOptionsConsts,
  DataFormatInstrumentSuggestions,
} from "../../../../api/DataFormatInstrument";
import { StringIndexedDict } from "../../../../api/GenericTypes";
import {
  GenericEntityVirtualizedEntitySelectFormFieldProps,
  GenericVirtualizedEntitySelectFormFieldControllerWrapper,
} from "../../../formfields/GenericVirtualizedSelectFormField/GenericVirtualizedEntitySelectFormFieldControllerWrapper";

export const DataFormatInstrumentsVirtualizedSelectForm = <Entity extends StringIndexedDict>(
  props: GenericEntityVirtualizedEntitySelectFormFieldProps<
    Entity,
    DataFormatInstrumentSuggestions,
    DataFormatInstrumentFilters
  >
) => {
  return (
    <GenericVirtualizedEntitySelectFormFieldControllerWrapper<
      Entity,
      DataFormatInstrumentSuggestions,
      DataFormatInstrumentFilters
    >
      {...props}
      filters={{ sortBy: [{ property: "ID", sortDirection: "ASC" }], ...props.filters }}
      //   onRowRenderer={(item) => <></>}
      entityConstants={dataFormatInstrumentsConstants}
      orderByOptions={DataFormatInstrumentSortingOptionsConsts}
      allowCreateEntity={false}
    />
  );
};
